<template>
  <v-row>
    <v-col
      cols="12"
      md="8"
    >
      <v-card>
        <v-form
          v-model="valid"
        >
          <v-container class="px-4">
            <div class="h2 pt-4 font-weight-bold">
              Identity
            </div>
            <v-row>
              <v-col
                cols="12"
                md="6"
              >
                <v-text-field
                  v-model="enumerator.email"
                  :rules="emailRules"
                  label="Email"
                  outlined
                  dense
                >
                </v-text-field>
              </v-col>
              <v-col
                cols="12"
                md="6"
              >
                <v-text-field
                  v-model="enumerator.phone"
                  :rules="required"
                  type="number"
                  label="Phone No"
                  outlined
                  dense
                >
                </v-text-field>
              </v-col>
              <v-col
                cols="12"
                md="6"
              >
                <v-select
                  v-model="enumerator.gender"
                  :items="genders"
                  label="Gender"
                  outlined
                  dense
                ></v-select>
              </v-col>
              <v-col
                cols="12"
                md="6"
              >
                <v-text-field
                  v-model="enumerator.age"
                  type="number"
                  label="Age"
                  outlined
                  dense
                ></v-text-field>
              </v-col>
              <v-col
                cols="12"
                md="6"
              >
                <v-text-field
                  v-model="enumerator.address"
                  :rules="required"
                  label="Address"
                  outlined
                  dense
                >
                </v-text-field>
              </v-col>
              <v-col
                cols="12"
                md="6"
              >
                <v-select
                  v-model="enumerator.edu_qua"
                  :items="academicqua"
                  label="Academic Qua"
                  outlined
                  dense
                ></v-select>
              </v-col>
              <v-col
                cols="12"
                md="6"
              >
                <v-select
                  v-model="enumerator.state"
                  :items="ngstate"
                  :rules="required"
                  label="State"
                  outlined
                  dense
                ></v-select>
              </v-col>
              <v-col
                cols="12"
                md="6"
              >
                <v-select
                  v-model="enumerator.lga"
                  :items="nglga[enumerator.state]"
                  :rules="required"
                  label="Lga"
                  outlined
                  dense
                  hide-details
                ></v-select>
              </v-col>
              <v-col
                cols="12"
                md="6"
                v-if="Object.entries(enumerator).length > 0 && enumerator.constructor === Object"
              >
                <v-select
                  v-model="enumerator.identification.type"
                  :items="idtype"
                  label="Identification Type"
                  outlined
                  dense
                  hide-details
                ></v-select>
              </v-col>
              <v-col
                v-if="Object.entries(enumerator).length > 0 && enumerator.constructor === Object"
                cols="12"
                md="6"
              >
                <v-text-field
                  v-model="enumerator.identification.number"
                  label="Identification No"
                  outlined
                  dense
                  hide-details
                ></v-text-field>
              </v-col>
            </v-row>
            <v-divider></v-divider>
            <v-card-actions>
              <v-btn
                :disabled="!valid"
                :loading="isLoading"
                color="error"
                depressed
              >
                <v-icon left>mdi-delete</v-icon>
                Clear
              </v-btn>
              <v-spacer></v-spacer>
              <v-btn
                :disabled="!valid"
                :loading="isLoading"
                color="primary"
                depressed
              >
                <v-icon left>mdi-checkbox-marked-circle</v-icon>
                Submit
              </v-btn>
            </v-card-actions>
          </v-container>
        </v-form>
        <v-form
          v-model="validpassword"
        >
          <v-container class="px-4">
            <div class="h2 pt-4 font-weight-bold">
              Change Password
            </div>
            <v-row>
              <v-col
                cols="12"
                md="6"
              >
                <v-text-field
                  v-model="password"
                  :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
                  :rules="required.concat(minRequired)"
                  :type="show1 ? 'text' : 'password'"
                  label="Password"
                  hint="At least 6 characters"
                  counter
                  @click:append="show1 = !show1"
                  outlined
                  dense
                >
                </v-text-field>
              </v-col>
              <v-col
                cols="12"
                md="6"
              >
                <v-text-field
                  v-model="confirmPassword"
                  :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
                  :rules="confirmRequired.concat(passwordConfirmation)"
                  :type="show1 ? 'text' : 'password'"
                  label="Confirm Password"
                  hint="At least 6 characters"
                  counter
                  @click:append="show1 = !show1"
                  outlined
                  dense
                >
                </v-text-field>
              </v-col>
            </v-row>
            <v-divider></v-divider>
            <v-card-actions>
              <v-btn
                :disabled="!validpassword"
                :loading="isLoading"
                color="error"
                depressed
              >
                <v-icon left>mdi-delete</v-icon>
                Clear
              </v-btn>
              <v-spacer></v-spacer>
              <v-btn
                :disabled="!validpassword"
                :loading="isLoading"
                color="primary"
                depressed
              >
                <v-icon left>mdi-checkbox-marked-circle</v-icon>
                Submit
              </v-btn>
            </v-card-actions>
          </v-container>
        </v-form>
      </v-card>
    </v-col>
    <!--others-/////////////////////////////////////////////////-->
    <v-col cols="12" md="4">
      <v-card>
        <div class="h2 px-4 pt-4 font-weight-bold">
          Bio
        </div>
        <v-row>
          <v-col class="pa-6" cols="12" align="center">
            <v-card class="image-card">
              <v-img
                :src= "enumerator.photo"
                lazy-src="../assets/placeholder.png"
                class="image-card"
              ></v-img>
            </v-card>
          </v-col>
        </v-row>
        <v-form v-model="formstatus">
          <v-container class="px-4">
            <v-row>
              <v-col
                cols="12"
              >
                <v-text-field
                  v-model="enumerator.first_name"
                  :rules="required"
                  label="First Name"
                  outlined
                  dense
                >
                </v-text-field>
              </v-col>
              <v-col
                cols="12"
              >
                <v-text-field
                  v-model="enumerator.last_name"
                  :rules="required"
                  label="Last Name"
                  outlined
                  dense
                >
                </v-text-field>
              </v-col>
              <div class="h2 px-4 pt-4 font-weight-bold">
                Status Information
              </div>
              <v-col
                cols="12"
              >
                <v-select
                  v-model="enumerator.status"
                  :items="['Active', 'Inactive']"
                  :rules="itemRequired"
                  label="Status"
                  outlined
                  dense
                >
                </v-select>
              </v-col>
            </v-row>
            <v-card-actions>
              <v-btn
                :disabled="!formstatus"
                :loading="isLoading"
                color="error"
                depressed
              >
                <v-icon left>mdi-delete</v-icon>
                Clear
              </v-btn>
              <v-spacer></v-spacer>
              <v-btn
                :disabled="!formstatus"
                :loading="isLoading"
                color="primary"
                depressed
              >
                <v-icon left>mdi-checkbox-marked-circle</v-icon>
                Update
              </v-btn>
            </v-card-actions>
          </v-container>
        </v-form>
      </v-card>
    </v-col>
    <v-dialog
      v-model="dialog"
      persistent
      max-width="350"
    >
      <v-card class="pa-5" max-width="350">
        <v-row
          v-if="isProcessing"
          class="fill-height ma-0"
          align="center"
          justify="center"
        >
          <div class="text-center py-2 primary--text name-style">Creating...</div>
        </v-row>
        <v-row
          v-if="!isProcessing"
          class="fill-height ma-0"
          align="center"
          justify="center"
        >
          <div v-if="error">
            <div class="text-center py-2 name-style error--text">Error Occured</div>
            <v-row class=" pt-1">
              <v-btn
                outlined
                color="primary"
                @click="dialog=false; error=false"
                class="ma-4"
              >
                Close
              </v-btn>
              <v-spacer></v-spacer>
              <v-btn
                outlined
                color="primary"
                class="ma-4"
              >
                Try Again
              </v-btn>
            </v-row>
          </div>
          <div v-if="success">
            <div class="text-center py-2 primary--text name-style">Account Created</div>
            <div class="text-center pt-1">
              <v-btn
                outlined
                color="primary"
                @click="dialog=false; success=false"
                class="ma-4"
              >
                Ok
              </v-btn>
            </div>
          </div>
        </v-row>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="dialog2"
      persistent
      max-width="350"
    >
      <v-card class="pa-5" max-width="350">
        <v-row
          v-if="isProcessing"
          class="fill-height ma-0"
          align="center"
          justify="center"
        >
          <div class="text-center py-2 primary--text name-style">Updating...</div>
        </v-row>
        <v-row
          v-if="!isProcessing"
          class="fill-height ma-0"
          align="center"
          justify="center"
        >
          <div v-if="error">
            <div class="text-center py-2 name-style error--text">Error Updating</div>
            <v-row class=" pt-1">
              <v-btn
                outlined
                color="primary"
                @click="dialog2=false; error=false"
                class="ma-4"
              >
                Close
              </v-btn>
              <v-spacer></v-spacer>
              <v-btn
                outlined
                color="primary"
                class="ma-4"
                @click="dialog2=false; error=false; onSubmit();"
              >
                Try Again
              </v-btn>
            </v-row>
          </div>
          <div v-if="success">
            <div class="text-center py-2 primary--text name-style">Update Successful</div>
            <div class="text-center pt-1">
              <v-btn
                outlined
                color="primary"
                @click="dialog2=false; success=false"
                class="ma-4"
              >
                Ok
              </v-btn>
            </div>
          </div>
        </v-row>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
// import EnumeratorService from '../services/EnumeratorService'
import { ngstate, nglga, genders, academicqua, idtype } from '../utils/Statelga'

export default {
  name: 'Enumerator',
  data: () => ({
    dialog: false,
    dialog2: false,
    isProcessing: false,
    error: false,
    success: false,
    enumerator: {},
    ngstate,
    nglga,
    genders,
    academicqua,
    idtype,
    lgas: [],
    selected: null,
    date: null,
    menu: false,
    show1: false,
    isLoading: false,
    valid: false,
    validpassword: false,
    password: '',
    email: '',
    formstatus: false,
    confirmPassword: '',
    itemRequired: [v => !!v || 'Item is required'],
    imageRules: [value => !value || value.size < 2000000 || 'Avatar size should be less than 2 MB!'],
    emailRules: [v => !!(v || '').match(/@/) || 'Please enter a valid email'],
    required: [value => !!value || 'Required.'],
    confirmRequired: [value => !!value || 'Confirm Required.']
  }),
  watch: {
    menu (val) {
      val && setTimeout(() => (this.$refs.picker.activePicker = 'YEAR'))
    }
  },
  /* async mounted () {
    const id = this.$route.params.id
    this.enumerator = await EnumeratorService.getEnumerator(id)
  }, */
  methods: {
    save (date) {
      this.$refs.menu.save(date)
    },
    statesChange: function (event) {
      if (this.state.length > 0) {
        this.lgas = this.nglga[this.state]
      }
    }
    /* async onSubmit () {
      this.dialog = true
      this.isProcessing = true
      const id = this.enumerator._id
      const formData = new FormData()
      formData.append('first_name', this.enumerator.first_name)
      formData.append('last_name', this.enumerator.last_name)
      formData.append('phone', this.enumerator.phone)
      formData.append('email', this.enumerator.email)
      formData.append('birthday', this.enumerator.birthday)
      formData.append('lga', this.enumerator.lga)
      formData.append('subcell', this.enumerator.subcell)
      formData.append('address', this.enumerator.address)
      formData.append('status', this.enumerator.status)
      formData.append('password', this.enumerator.password)
      formData.append('createdAt', this.enumerator.createdAt)
      formData.append('photo', this.selected)

      await EnumeratorService.updateEnumerators(id, formData)
        .then((res) => {
          console.log(res)
          this.isProcessing = false
          if (res.status === 201) {
            this.success = true
          }
        })
        .catch((err) => {
          console.log(err.response)
          this.isProcessing = false
          this.error = true
        })
    },
    async onUpdate () {
      this.dialog2 = true
      this.isProcessing = true
      const id = this.enumerator._id
      const formData = new FormData()
      formData.append('status', this.enumerator.status)

      await EnumeratorService.updateStatus(id, formData)
        .then((res) => {
          console.log(res)
          this.isProcessing = false
          if (res.status === 201) {
            this.success = true
          }
        })
        .catch((err) => {
          console.log(err.response)
          this.isProcessing = false
          this.error = true
        })
    } */
  },
  computed: {
    minRequired () {
      return () => this.password.length >= 6 || 'Min 6 character'
    },
    passwordConfirmation () {
      return () => this.password === this.confirmPassword || 'Password must match'
    }
  }
}
</script>

<style lang="scss" scoped>
.image-card{
  max-height: 300px;
  max-width: 300px
}
@media(max-height: 640px) {
  .image-card{
    height: 250px;
    width: 250px
  }
}
@media(max-height: 740px) and (min-height: 641px) {
  .image-card{
    height: 250px;
    width: 250px
  }
}
@media(max-height: 840px) and (min-height: 741px) {
  .image-card{
    height: 300px;
    width: 300px
  }
}
</style>
